import LandingCenter from "../landingCenter/LandingCenter.jsx";
import LandingFooter from "../landingFooter/LandingFooter.jsx";
import LandingHeader from "../landingHeader/LandingHeader.jsx";
function LandingPage() {
  return (
    <div className="landing-page">
      <LandingHeader />
      <LandingCenter />
      <LandingFooter />
    </div>
  );
}

export default LandingPage;
